import { QueryKey } from 'constants/reactQuery';

export const rollingReactionQueryKey = {
  rollingsKey: [QueryKey.Rolling, 'reaction'] as const,
  rolling: (rollingId: number) => [...rollingReactionQueryKey.rollingsKey, rollingId] as const,
  rollings: (rollingIds: number[]) => [...rollingReactionQueryKey.rollingsKey, ...rollingIds] as const,
};
